<div class="container">
	<div class="result-actions-menu" id="searchResultsMenu" *ngIf="loaded">
		<form>
			<ion-list lines="none">
				<ng-container *ngFor="let m of members">
					<ion-item button="true" lines="none">
						<ion-card class="provider-result-info-card" style="width: 100%" (click)="(m.canKeepPlan)">
							<ion-card-content>
								<ion-label text-wrap>
									<mat-checkbox
										class="custom-mat-radio-button"
										(change)="entityChecked($event.checked, m)"
										[(checked)]="m.selected"
										[disabled]="!m.canKeepPlan"
									>
										<div class="inner-content">
											<div
												class="name-age-container"
												[ngClass]="{
													'enrollment-container': !hasCurrentEnrollmentDate(m.enrollments)
												}"
											>
												<span
													><b>{{ m.fullName }}&nbsp;</b></span
												>
												<span> ({{ 'AGE' | translate }} {{ m.recipientAge }})</span>
											</div>
											<ng-container *ngFor="let enroll of m.enrollments">
												<div *ngIf="enroll.currentEnrollmentDate">
													{{ enroll.currentHealthPlanDescription }}
												</div>
											</ng-container>
										</div>
									</mat-checkbox>
								</ion-label>
							</ion-card-content>
						</ion-card>
					</ion-item>
				</ng-container>
			</ion-list>
			<mat-checkbox
				class="check-box-confirm"
				[(checked)]="selectedMembers.verifyCommit"
				(change)="verifyCheckedfn($event.checked)"
				[disabled]="!oneMemberSelected"
			>
				<span class="wrap-text">{{ 'KEEPPLAN_VERIFY' | translate }}</span>
			</mat-checkbox>
		</form>
	</div>
</div>
